// Exposes several smaller components used in ProductVariant.
// It didn't made much sense to separate them by multiple files
// since they are quite small/simple and contained.

import { bool, node, number, string } from 'prop-types'

import IconNotification from 'views/components/atoms/Icon/IconNotification'
import Price from 'views/components/atoms/Price'
import PriceOld from 'views/components/atoms/PriceOld'
import ButtonTooltip from 'views/components/molecules/ButtonTooltip'
import ProductVariantBadge from 'views/components/organisms/ProductVariants/ProductVariant/ProductVariantBadge'

export const OutOfStockNotification = () => (
  <span
    className="o-ProductVariantMain__email-notification-icon"
    data-clientside-hook="o-ProductVariantMain__email-notification-icon"
    aria-hidden
  >
    <ButtonTooltip
      name="email-subscribed-notification-tooltip"
      id="email-subscribed-notification-tooltip"
      sideRendered="left"
      text="Benachrichtigung bei Wiederverfügbarkeit aktiv"
      inline
    >
      <IconNotification size="large" sizeSmallTiny="large" />
    </ButtonTooltip>
  </span>
)

export const ListPrice = ({ amount, currency, noLineThrough }) =>
  amount && (
    <PriceOld
      amount={amount}
      currency={currency}
      inheritColor
      noLineThrough={noLineThrough}
    />
  )

ListPrice.propTypes = {
  noLineThrough: bool.isRequired,
  amount: number,
  currency: string,
}

ListPrice.defaultProps = {
  amount: null,
}

export const RetailPrice = ({
  amount,
  currency,
  isMasterPage,
  lowestPrice,
}) => {
  return (
    <Price
      amount={isMasterPage ? lowestPrice : amount}
      currency={currency}
      isMasterPage={isMasterPage}
      inheritColor
    />
  )
}

RetailPrice.propTypes = {
  amount: number,
  currency: string,
  isMasterPage: bool,
  lowestPrice: number,
}
RetailPrice.defaultProps = {
  isMasterPage: false,
  lowestPrice: 0,
}

export const DiscountBadge = props => (
  <>
    <span
      className="o-ProductVariantMain__discount_badge"
      data-clientside-hook="o-ProductVariantMain__discount_badge"
    >
      <ProductVariantBadge {...props} />
    </span>

    {props.isOutOfStock && <OutOfStockNotification />}
  </>
)

DiscountBadge.propTypes = {
  isOutOfStock: bool,
}

DiscountBadge.defaultProps = {
  isOutOfStock: false,
}

export const VariantColumn = ({
  children,
  labeledBy,
  prescriptionTypeData,
  className,
}) => {
  return (
    <div
      className={className}
      aria-labelledby={labeledBy}
      data-prescription-type-template={prescriptionTypeData}
    >
      {children}
    </div>
  )
}

VariantColumn.propTypes = {
  labeledBy: string.isRequired,
  children: node.isRequired,
  prescriptionTypeData: bool,
  className: string,
}

VariantColumn.defaultProps = {
  prescriptionTypeData: null,
  className: null,
}
